import { clsx, type ClassValue } from 'clsx';
import { extendTailwindMerge } from 'tailwind-merge';
import { TYPE_PRESETS } from './typeScale';

/**
 * Merge class names, later Tailwind utilities winning. The type presets (`text-row-title`, `text-timer`, …) live in
 * the `text-` namespace alongside colours, so they are declared as font-size: without this, merging a preset with a
 * colour silently drops the colour and buttons lose their label.
 */
const twMerge = extendTailwindMerge({ extend: { classGroups: { 'font-size': [{ text: [...TYPE_PRESETS] }] } } });

export const cn = (...inputs: ClassValue[]) => twMerge(clsx(inputs));
